import { computed } from "vue";
import { useStore } from "vuex";
import { hasShowGlobalTranscriptReleaseFormEnabled } from "@/composables/authorization.js";
import { FORMS_SUBMISSIONS } from "@/constants.js";

export const useShowTranscriptReleaseTile = () => {
  const store = useStore();

  const postAcceptanceFormRules = computed(() => store.state.program?.post_acceptance_form_rules ?? []);

  const showPostAcceptanRule = (rules) => {
    return (
      Array.isArray(postAcceptanceFormRules.value) &&
      postAcceptanceFormRules.value.length > 0 &&
      rules.some((r) => postAcceptanceFormRules.value.includes(r))
    );
  };

  const showTranscriptReleaseTile = computed(
    () =>
      showPostAcceptanRule([FORMS_SUBMISSIONS.transcriptRelease.name]) &&
      hasShowGlobalTranscriptReleaseFormEnabled.value,
  );

  return { showTranscriptReleaseTile };
};
